import { IFileData } from "@/features/clientProjectDetails";
import { SelectedFilesWithMultiParts } from "../api";
import { MEDIA_TYPE_EXTN } from "@/features/clientSearch/constant";

export type UploadedOrUppyFile = {
  [key: string]: IFileData & SelectedFilesWithMultiParts;
};

export type MultiPartsFileObj = {
  [key: string]: SelectedFilesWithMultiParts;
};

export interface IFilterFiles {
  data?: UploadedOrUppyFile;
  fileTypeString?: MEDIA_TYPE_EXTN;
  fileTypeEnum?: string;
  excludeFiles?: {
    [key: string]: any;
  };
}

export const filterFiles = ({
  data,
  fileTypeString,
  fileTypeEnum,
  excludeFiles
}: IFilterFiles) => {
  const _temp: any = {};
  if (!data) {
    return null;
  }
  Object.keys(data).forEach((fileKey: string) => {
    if (excludeFiles && fileKey in excludeFiles) {
      return;
    }
    if (
      (fileTypeString &&
        data[fileKey]?.fileData &&
        data[fileKey]?.fileData?.type?.startsWith(fileTypeString)) ||
      (fileTypeEnum && data[fileKey].fileType === fileTypeEnum)
    ) {
      _temp[fileKey] = data[fileKey];
    }
  });
  return _temp;
};

export interface IGetCount {
  files: any;
  uploadedFiles: any;
  showStatusOfSelectedFile: boolean;
}

export const getCount = ({
  files,
  uploadedFiles,
  showStatusOfSelectedFile
}: IGetCount): number => {
  let count = 0;
  if (files) {
    count += Object.keys(files).length;
  }
  if (!showStatusOfSelectedFile && uploadedFiles) {
    count += Object.keys(uploadedFiles).length;
  }
  return count;
};
